<template>
  <!-- begin #footer -->
  <div id="footer" class="footer" style="background-color: white">
    <img
      height="32px"
      width="32px"
      style="margin-right: 16px; margin-left: 16px"
      src="/assets/img/logo_base.png"
      alt=""
    />

    &copy; {{ brandLine }} -
    <b>{{ $t("messages.copyrightCompany") }}</b>
    <b>{{ $t("messages.allRightsReserved") }}</b>
    <b>{{ new Date().getFullYear() }}</b>
  </div>
  <!-- end #footer -->
</template>

<script>
import PageOptions from "../../config/PageOptions.vue";
import { resolveProductKey } from "@/utils/productIdentity.js";

export default {
  name: "Footer",
  data() {
    return {
      pageOptions: PageOptions,
      productKey: resolveProductKey(),
    };
  },
  computed: {
    brandLine() {
      return this.$t(`landing.products.${this.productKey}.brandLine`);
    },
  },
};
</script>
